import React from 'react'
import PropTypes from 'prop-types'
import DropdownCollection from './DropdownCollection'
import RadioCollection from './RadioCollection'

const Collection = (props) => {
  let Component
  if (
    props.dataGroup === 'ad_types' ||
    props.id === 'clothing_gender' ||
    props.id === 'clothing_children_gender'
  ) {
    Component = RadioCollection
  } else {
    Component = DropdownCollection
  }

  return <Component {...props} />
}

export default Collection

Collection.propTypes = {
  id: PropTypes.string,
  dataGroup: PropTypes.string,
}
